import React from 'react';
import { Typography, Box, Container, Grid, Stack, Link } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { IMAGES, PHONE_DISPLAY, PHONE_HREF } from '../theme';
export function Footer() {
  return <Box component="footer" sx={{
    bgcolor: '#063E49',
    color: 'white',
    py: 6
  }} data-id="element-14">
      <Container maxWidth="lg" data-id="element-15">
        <Grid container spacing={4} justifyContent="space-between" data-id="element-16">
          <Grid item xs={12} md={5} data-id="element-17">
            <Box sx={{
            display: 'inline-flex',
            bgcolor: 'white',
            borderRadius: 2,
            p: 1.5,
            mb: 2
          }} data-id="element-18">
              <Box component="img" src={IMAGES.logo} alt="The Patio Cover Company" sx={{
              height: 64,
              objectFit: 'contain'
            }} data-id="element-19" />
            </Box>
            <Typography variant="body2" sx={{
            opacity: 0.7,
            maxWidth: 360
          }} data-id="element-20">
              A proudly woman-owned company building premium custom patio covers
              and pergolas for Brentwood, CA and the surrounding East Bay
              communities. Proudly supporting our first responders & veterans.
            </Typography>
          </Grid>

          <Grid item xs={12} md={4} data-id="element-21">
            <Typography variant="subtitle1" fontWeight="bold" sx={{
            mb: 2
          }} data-id="element-22">
              Get In Touch
            </Typography>
            <Stack spacing={1.5} data-id="element-23">
              <Stack direction="row" spacing={1.5} alignItems="center" data-id="element-24">
                <PhoneIcon color="secondary" fontSize="small" data-id="element-25" />
                <Link href={PHONE_HREF} underline="hover" sx={{
                color: 'white',
                opacity: 0.85
              }} data-id="element-26">
                  {PHONE_DISPLAY}
                </Link>
              </Stack>
              <Stack direction="row" spacing={1.5} alignItems="center" data-id="element-27">
                <LocationOnIcon color="secondary" fontSize="small" data-id="element-28" />
                <Typography variant="body2" sx={{
                opacity: 0.85
              }} data-id="element-29">
                  Brentwood, CA & Surrounding Areas
                </Typography>
              </Stack>
            </Stack>
          </Grid>
        </Grid>

        <Box sx={{
        mt: 5,
        pt: 3,
        borderTop: '1px solid rgba(255,255,255,0.1)'
      }} data-id="element-30">
          <Typography variant="body2" sx={{
          opacity: 0.6
        }} data-id="element-31">
            &copy; {new Date().getFullYear()} The Patio Cover Company. All
            rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>;
}